var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserManagementIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_248_4560)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.75269 35.777V30.4863C8.75269 25.2896 12.9664 21.0723 18.1631 21.0723C21.1265 21.0723 23.7718 22.4419 25.4956 24.5813",
    stroke: "#276AE2",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5331 18.5377C26.4969 15.5739 26.4969 10.7688 23.5331 7.80512C20.5694 4.8414 15.7643 4.8414 12.8006 7.80511C9.83689 10.7688 9.83689 15.5739 12.8006 18.5377C15.7643 21.5014 20.5694 21.5014 23.5331 18.5377Z",
    stroke: "#276AE2",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.4023 36.0697C32.3222 36.0697 34.6893 33.7026 34.6893 30.7826C34.6893 27.8627 32.3222 25.4956 29.4023 25.4956C26.4823 25.4956 24.1152 27.8627 24.1152 30.7826C24.1152 33.7026 26.4823 36.0697 29.4023 36.0697Z",
    stroke: "#27C3E2",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.2627 30.6812H31.5595",
    stroke: "#27C3E2",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.4131 32.8315V28.5347",
    stroke: "#276AE2",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_248_4560"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserManagementIcon);
export default __webpack_public_path__ + "static/media/UserManagementIcon.c408b34d97e2457129e9ff5bb548644c.svg";
export { ForwardRef as ReactComponent };